import { render } from "./app.vue?vue&type=template&id=568128c0"
const script = {}

import "./app.vue?vue&type=style&index=0&id=568128c0&lang=scss"

import exportComponent from "/data/soft/jenkins/jobs/release-ms-front/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__